/* @ngInject */
function ArtSizeDialogController ($scope, $rootScope, $timeout, $translate, $state, $window, $stateParams, ToastService, ArtSizesService, ArtsService, SegmentService, ConfirmationModalService, Utils) {
  $scope.recents = {
    artSizes: [],
    count: null
  }
  $scope.suggestions = {
    artSizes: [],
    count: null
  }
  $scope.favorites = {
    artSizes: [],
    count: null,
    index: 0
  }
  $scope.searched = {
    artSizes: [],
    count: null,
    index: 0,
    term: '',
    width: null,
    height: null
  }

  $scope.flags = {
    loadingArtSizes: false,
    loadingMore: false,
    loadingButton: false,
    isSearching: false,
    blockSearch: false
  }

  $scope.showFavoriteCard = true

  $scope.rename = null

  $scope.unitOptions = [
    { label: 'px', value: 'PX', active: true },
    { label: 'cm', value: 'CM' }
  ]

  $scope.bleedAreaOptions = [
    { label: $translate.instant('select'), value: null, active: true },
    { label: '3 mm', value: '3MM' },
    { label: '5 mm', value: '5MM' },
    { label: '10 mm', value: '10MM' },
    { label: '30 mm', value: '30MM' },
    { label: '50 mm', value: '50MM' }
  ]

  $scope.selectedTab = 'recents'
  $scope.selectedArtSize = null

  $scope.newArtSize = {
    width: '',
    height: '',
    measureUnit: 'PX',
    bleedArea: null,
    scaledWidth: '',
    scaledHeight: '',
    isFavorite: false
  }

  $scope.needsScale = false

  $scope.proportion = {
    active: false,
    width: '',
    height: ''
  }

  const top = 21

  $scope.select = {
    unitValue: null,
    bleedValue: null
  }

  const api = {
    _getRecentArtSizes,
    _successGetRecentArtSizes,
    _getSuggestedArtSizes,
    _successGetSuggestedArtSizes,
    _getFavoriteArtSizes,
    _successGetFavoriteArtSizes,
    _initializeInfiniteScroll,
    _verifyNewArtSizeForm,
    _calculateProportion,
    _checkScale,
    _calculateScale,
    _clearScale,
    _setSearchParams,
    _searchArtSizes,
    _successGetSearchedArtSizes,
    _clearSearch,
    _unselectTabs,
    _selectCurrentTab,
    _validateCharacter,
    _validateIfIsDecimal,
    _saveNewArtSize,
    _favoriteArtSize,
    _afterSaveNewArtSize,
    _clearNewArtSizeForm,
    _openEditor,
    _fillArtSizeForm,
    _getFormattedBleed,
    _renameArtSize,
    _onSearch: Utils.debounce(_onSearch)
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._getRecentArtSizes()
    api._getSuggestedArtSizes()
    api._getFavoriteArtSizes(0, true)
    api._initializeInfiniteScroll()
  }

  $scope.getModalTitle = () => {
    return $rootScope.isUserSysAdminAdminDesigner() ? $translate.instant('artSizeDialogTitleAdmin') : $translate.instant('artSizeDialogTitleUser')
  }

  $scope.getButtonText = () => {
    if ($scope.data.updateArtSize) {
      return $translate.instant('editTemplate')
    }

    return $rootScope.isUserSysAdminAdminDesigner() ? $translate.instant('createTemplate') : $translate.instant('createBlankArt')
  }

  $scope.handleTabChange = (event) => {
    if (event.detail.name) {
      $scope.selectedTab = event.detail.name
    }
  }

  $scope.onTabsClick = () => {
    if ($scope.flags.isSearching) {
      api._clearSearch()
    }
  }

  $scope.getArtSizeMeasurements = (artSize) => {
    let width = artSize.width
    let height = artSize.height

    if (artSize.measureUnit === 'CM') {
      width = parseFloat(artSize.originalWidth)
      height = parseFloat(artSize.originalHeight)
    }

    if (!width || !height) {
      width = Utils.convertPixelsToCm(artSize.width)
      height = Utils.convertPixelsToCm(artSize.height)
    }

    return `${width} x ${height}`
  }

  $scope.getArtSizeTitle = (name) => {
    return name || $translate.instant('noName')
  }

  $scope.getPreviewStyle = (info) => {
    const artSizeHeight = info.height
    const artSizeWidth = info.width

    let width = 60
    let height = 80

    if (artSizeWidth > artSizeHeight) {
      width = 80
      height = 50
    } else if (artSizeWidth === artSizeHeight) {
      width = 70
      height = 70
    }

    return {
      width,
      height
    }
  }

  $scope.loadMoreFavoriteArtSizes = () => {
    $scope.flags.loadingMore = true
    $scope.favorites.index++
    api._getFavoriteArtSizes($scope.favorites.index)
  }

  $scope.loadMoreSearchedArtSizes = () => {
    $scope.flags.loadingMore = true
    $scope.searched.index++
    api._searchArtSizes()
  }

  $scope.selectArtSize = (artSize) => {
    $scope.selectedArtSize = artSize
    api._fillArtSizeForm(artSize)
  }

  $scope.enableTitleInput = (artSize) => {
    $scope.selectArtSize(artSize)
    artSize.nameToEdit = artSize.name
    $scope.rename = artSize

    $timeout(() => {
      $('.art-sizes-list .art-size-item uds-dropdown').attr('show', false)
      $('.art-sizes-list .art-size-item .title-input input').focus()
    }, 0, false)
  }

  $scope.onBackgroundClick = () => {
    if (!$scope.rename) return
    api._renameArtSize()
  }

  $scope.onTitleInputKeydown = (event) => {
    if (event.key === 'Enter') {
      api._renameArtSize()
    }
  }

  $scope.deleteArtSize = function (artSize) {
    ArtSizesService.deleteArtSize(artSize.id).then(() => {
      ToastService.showSuccessToast($translate.instant('artSizeDeletedSuccess'))
      if ($scope.selectedTab === 'recents') {
        api._getRecentArtSizes()
      } else {
        api._getFavoriteArtSizes(0, true)
      }
      api._initializeInfiniteScroll()
    }).catch(ToastService.defaultErrorToast)
  }

  $scope.isBleedAreaDisabled = () => {
    return $scope.newArtSize.measureUnit === 'PX'
  }

  $scope.isFavoriteToggleDisabled = () => {
    return !$scope.newArtSize.width || !$scope.newArtSize.height
  }

  $scope.onInputChange = (event, type) => {
    const value = event.detail.value
    $scope.newArtSize[type] = value

    if (type !== 'bleedArea') {
      api._checkScale()
    }

    if ($scope.selectedArtSize && $scope.newArtSize[type].toString() !== $scope.selectedArtSize[type]?.toString()) {
      $scope.selectedArtSize = null
      $scope.newArtSize.isFavorite = false
      $('.favorite-toggle uds-toggle').attr('checked', false)
    }

    if (!$scope.flags.blockSearch) {
      api._onSearch()
    }
  }

  function _onSearch () {
    if (!$scope.newArtSize.width && !$scope.newArtSize.height) {
      api._clearSearch()
      api._selectCurrentTab()
    } else {
      api._unselectTabs()
      $scope.flags.isSearching = true
      $scope.flags.loadingArtSizes = true
      $scope.searched.term = ''
      $scope.searched.width = $scope.newArtSize.width
      $scope.searched.height = $scope.newArtSize.height
      api._searchArtSizes(true)
    }
  }

  $scope.onInputType = (event, type) => {
    if (event.detail?.data) {
      api._validateCharacter(event.detail.data, type)
    }
    api._calculateProportion(type)
  }

  $scope.hideFavoriteCard = () => {
    $scope.showFavoriteCard = false
  }

  $scope.isCreateButtonDisabled = () => {
    const newArtSize = $scope.newArtSize.height && $scope.newArtSize.width
    return !$scope.selectedArtSize && !newArtSize
  }

  $scope.getMaxScaleSize = () => {
    const sizes = {
      PX: '3000 px',
      CM: '100 cm'
    }

    return sizes[$scope.newArtSize.measureUnit]
  }

  $scope.proportionClick = () => {
    $scope.proportion.active = !$scope.proportion.active
    $scope.proportion.width = $scope.newArtSize.width
    $scope.proportion.height = $scope.newArtSize.height
  }

  $scope.onToggleChange = (event) => {
    const { value } = event.detail

    $scope.newArtSize.isFavorite = value
    if ($scope.selectedArtSize) {
      api._favoriteArtSize(value, api._afterSaveNewArtSize)
    }
  }

  $scope.createTemplateClick = () => {
    const createTemplate = () => {
      if ($scope.selectedArtSize) {
        api._openEditor($scope.selectedArtSize)
      } else {
        api._verifyNewArtSizeForm()
        api._saveNewArtSize(api._openEditor)
      }
    }

    if ($scope.data.updateArtSize) {
      ConfirmationModalService.createModal({
        description: $translate.instant('confirmArtboardResize'),
        onConfirm: createTemplate
      })
    } else {
      createTemplate()
    }
  }

  $scope.onArtSizeSearchChange = Utils.debounce((event) => {
    const value = event.detail.value

    if (value) {
      api._unselectTabs()
      $scope.flags.isSearching = true
      $scope.flags.loadingArtSizes = true
      api._setSearchParams(value)
      api._searchArtSizes(true)
    } else {
      api._clearSearch()
      api._selectCurrentTab()
    }
  })

  $scope.getSearchParams = () => {
    if ($scope.searched.term) {
      return $scope.searched.term
    } else if ($scope.searched.width && $scope.searched.height) {
      return $scope.searched.width + ' x ' + $scope.searched.height
    } else if ($scope.searched.width) {
      return $scope.searched.width
    } else {
      return $scope.searched.height
    }
  }

  function _getRecentArtSizes () {
    $scope.flags.loadingArtSizes = true
    const params = {
      filter: 'recents'
    }

    ArtSizesService.getArtSizes(params).then(api._successGetRecentArtSizes)
  }

  function _successGetRecentArtSizes (res) {
    const { rows, count } = res
    $scope.recents.artSizes = rows
    $scope.recents.count = count

    if (!$scope.recents.count) {
      $scope.selectedTab = 'favorites'
    }

    $timeout(() => {
      api._selectCurrentTab()
    }, 200, true)

    $scope.flags.loadingArtSizes = false
  }

  function _getSuggestedArtSizes () {
    $scope.flags.loadingArtSizes = true
    const params = {
      filter: 'suggestions'
    }

    ArtSizesService.getArtSizes(params).then(api._successGetSuggestedArtSizes)
  }

  function _successGetSuggestedArtSizes (res) {
    const { rows, count } = res
    $scope.suggestions.artSizes = rows
    $scope.suggestions.count = count
    $scope.flags.loadingArtSizes = false
  }

  function _getFavoriteArtSizes (index, reload) {
    if (reload) {
      $scope.flags.loadingArtSizes = true
    }

    const params = {
      top: top,
      skip: top * index,
      filter: 'favorites'
    }

    ArtSizesService.getArtSizes(params).then(res => api._successGetFavoriteArtSizes(res, reload))
  }

  function _successGetFavoriteArtSizes (res, reload) {
    const { rows, count } = res

    if (reload) {
      $scope.favorites.artSizes = rows
      $scope.favorites.index = 0
    } else {
      $scope.favorites.artSizes.push(...rows)
    }

    $scope.favorites.count = count

    if (!$scope.favorites.count) {
      $scope.selectedTab = 'suggestions'
      $timeout(() => {
        api._selectCurrentTab()
      }, 500, true)
    }

    $scope.flags.loadingArtSizes = false
    $scope.flags.loadingMore = false
  }

  function _setSearchParams (value) {
    if (value.includes(' x ') || value.includes(' X ')) {
      let values = []

      if (value.includes(' x ')) {
        values = value.split(' x ')
      } else {
        values = value.split(' X ')
      }

      $scope.searched.width = values[0]
      $scope.searched.height = values[1]
    } else {
      $scope.searched.term = value
    }
  }

  function _searchArtSizes (reload) {
    const params = {
      top,
      skip: top * $scope.searched.index,
      search: $scope.searched.term,
      width: $scope.searched.width,
      height: $scope.searched.height,
      measureUnit: $scope.newArtSize.measureUnit
    }

    ArtSizesService.getArtSizes(params).then(res => api._successGetSearchedArtSizes(res, reload))
  }

  function _successGetSearchedArtSizes (res, reload) {
    const { rows, count } = res

    if (reload) {
      $scope.searched.artSizes = rows
      $scope.searched.index = 0
    } else {
      $scope.searched.artSizes.push(...rows)
    }

    const { measureUnit, bleedArea, height, width } = $scope.newArtSize

    $scope.selectedArtSize = $scope.searched.artSizes.find(row => {
      const isSameMeasureUnit = row.measureUnit === measureUnit
      const isSameBleedArea = row.bleedArea === bleedArea
      let isSameHeight = String(row.height) === height
      let isSameWidth = String(row.width) === width

      if (measureUnit === 'CM') {
        isSameHeight = parseFloat(row.originalHeight) === parseFloat(height)
        isSameWidth = parseFloat(row.originalWidth) === parseFloat(width)
      }

      return (
        isSameMeasureUnit &&
        isSameBleedArea &&
        isSameHeight &&
        isSameWidth
      )
    })

    $scope.searched.count = count
    $scope.flags.loadingArtSizes = false
    $scope.flags.loadingMore = false
  }

  function _clearSearch () {
    $scope.flags.isSearching = false
    $scope.searched = {
      artSizes: [],
      count: null,
      index: 0,
      term: '',
      width: null,
      height: null
    }

    $('.art-size-dialog .search-art-size-input').attr('value', '')
  }

  function _verifyNewArtSizeForm () {
    if ($scope.newArtSize.measureUnit === 'PX') {
      $scope.newArtSize.bleedArea = null
    }

    $scope.newArtSize.height = parseFloat($scope.newArtSize.height)
    $scope.newArtSize.width = parseFloat($scope.newArtSize.width)
    $scope.newArtSize.scaledHeight = parseFloat($scope.newArtSize.scaledHeight) || null
    $scope.newArtSize.scaledWidth = parseFloat($scope.newArtSize.scaledWidth) || null
  }

  function _calculateProportion (changedInput) {
    if (!$scope.proportion.active) return

    const proportionWidth = parseFloat($scope.proportion.width) || null
    const proportionHeight = parseFloat($scope.proportion.height) || null
    const artSizeWidth = parseFloat($scope.newArtSize.width) || 0
    const artSizeHeight = parseFloat($scope.newArtSize.height) || 0

    if (changedInput === 'width') {
      if (!proportionWidth || !proportionHeight) {
        $scope.newArtSize.height = $scope.newArtSize.width
      } else {
        $scope.newArtSize.height = proportionHeight * artSizeWidth / proportionWidth
      }

      if ($scope.newArtSize.height === 0) {
        $scope.newArtSize.height = ''
      }

      $('.art-size-inputs .height-input').attr('value', $scope.newArtSize.height)
    } else {
      if (!proportionWidth || !proportionHeight) {
        $scope.newArtSize.width = $scope.newArtSize.height
      } else {
        $scope.newArtSize.width = proportionWidth * artSizeHeight / proportionHeight
      }

      if ($scope.newArtSize.width === 0) {
        $scope.newArtSize.width = ''
      }
      $('.art-size-inputs .width-input').attr('value', $scope.newArtSize.width)
    }
  }

  function _checkScale () {
    const maxValues = {
      PX: 3000,
      CM: 100
    }

    const maxValue = maxValues[$scope.newArtSize.measureUnit]

    if (parseFloat($scope.newArtSize.width) > maxValue || parseFloat($scope.newArtSize.height) > maxValue) {
      $scope.needsScale = true
      api._calculateScale(maxValue)
    } else {
      $scope.needsScale = false
      api._clearScale()
    }
  }

  function _calculateScale (baseValue) {
    const artSizeWidth = parseFloat($scope.newArtSize.width) || 0
    const artSizeHeight = parseFloat($scope.newArtSize.height) || 0
    let newHeight = 0
    let newWidth = 0

    if (artSizeWidth > artSizeHeight) {
      newWidth = baseValue
      newHeight = (artSizeHeight * (newWidth / artSizeWidth))
    } else {
      newHeight = baseValue
      newWidth = (artSizeWidth * (newHeight / artSizeHeight))
    }

    $scope.newArtSize.scaledHeight = Number(newHeight.toFixed(2))
    $scope.newArtSize.scaledWidth = Number(newWidth.toFixed(2))
    $('.art-size-inputs .scaling-width-input').attr('value', $scope.newArtSize.scaledWidth)
    $('.art-size-inputs .scaling-height-input').attr('value', $scope.newArtSize.scaledHeight)
  }

  function _clearScale () {
    $scope.newArtSize.scaledHeight = 0
    $scope.newArtSize.scaledWidth = 0
    $('.art-size-inputs .scaling-width-input').attr('value', $scope.newArtSize.scaledWidth)
    $('.art-size-inputs .scaling-height-input').attr('value', $scope.newArtSize.scaledHeight)
  }

  function _unselectTabs () {
    $('.art-size-dialog uds-tabs').attr('selected', '')
    $('.art-size-dialog uds-tab').attr('selected', false)
    $('.art-size-dialog uds-tab-content').attr('visible', false)
  }

  function _selectCurrentTab () {
    $timeout(() => {
      $('.art-size-dialog uds-tabs').attr('selected', $scope.selectedTab)
      $(`.art-size-dialog uds-tab[name="${$scope.selectedTab}"]`).attr('selected', true)
      $(`.art-size-dialog uds-tab-content[name="${$scope.selectedTab}"]`).attr('visible', true)
    }, 100)
  }

  function _validateCharacter (value, type) {
    const isNumber = /[0-9]/.test(value)

    if (!isNumber) {
      const isDecimal = api._validateIfIsDecimal(value)
      if (isDecimal) return

      const types = {
        width: $scope.newArtSize.width,
        height: $scope.newArtSize.height
      }
      let measure = types[type]

      measure = measure.slice(0, -1)
      $(`.art-size-inputs .${type}-input`).attr('value', measure)
    }
  }

  function _validateIfIsDecimal (value) {
    if ($scope.newArtSize.measureUnit === 'PX') return false
    return value === '.'
  }

  function _saveNewArtSize (callback) {
    ArtSizesService.createArtSize($scope.newArtSize).then(callback).catch(ToastService.defaultErrorToast)
  }

  function _favoriteArtSize (value, callback) {
    ArtSizesService.setArtSizeFavorite($scope.selectedArtSize.id, value).then(callback)
  }

  function _afterSaveNewArtSize (info) {
    if (info?.id) {
      SegmentService.track('editor-art-size-favorite', { id: info.id })
    }

    api._clearSearch()
    api._clearNewArtSizeForm()
    api._unselectTabs()
    $scope.selectedTab = 'favorites'
    api._selectCurrentTab()
    api._getFavoriteArtSizes(0, true)
    api._initializeInfiniteScroll()
  }

  function _clearNewArtSizeForm () {
    $scope.newArtSize = {
      width: '',
      height: '',
      measureUnit: 'PX',
      bleedArea: null,
      scaledWidth: '',
      scaledHeight: '',
      isFavorite: false
    }

    $timeout(() => {
      $('.art-size-inputs uds-input').attr('value', '')
      $('.scaling uds-input').attr('value', '')
      $('.favorite-toggle uds-toggle').attr('checked', false)
    }, 0)
  }

  function _openEditor (measure) {
    $scope.close()

    ArtSizesService.setArtSizeAsRecent(measure.id)

    if ($scope.data.updateArtSize) {
      const svg = document.querySelector('#canvas0').instance
      const arboardSize = `${svg.width()}x${svg.height()}`
      $stateParams.resizeArt = arboardSize

      ArtsService.updateArtSize($scope.data.newArtId, measure.id).then(() => {
        const url = $state.href('customizeArt', {
          idArt: $scope.data.newArtId,
          resizeArt: arboardSize
        })

        $window.open(url, '_blank')
      })
    } else {
      $state.go('startFromBlank', {
        id: measure.id,
        artCollectionId: $scope.data.artCollectionId,
        fromParams: $state.params,
        campaign: $scope.data.campaign,
        from: $state.current.name,
        location: $scope.data.location
      })
    }
  }

  function _fillArtSizeForm (artSize) {
    const width = artSize.measureUnit === 'CM' ? artSize.originalWidth : artSize.width
    const height = artSize.measureUnit === 'CM' ? artSize.originalHeight : artSize.height

    $scope.newArtSize = {
      width,
      height,
      measureUnit: artSize.measureUnit,
      bleedArea: artSize.bleedArea,
      scaledWidth: artSize.scaledWidth,
      scaledHeight: artSize.scaledHeight,
      isFavorite: artSize.isFavorite
    }

    $scope.flags.blockSearch = true

    $('.art-size-inputs .width-input').val($scope.newArtSize.width)
    $('.art-size-inputs .height-input').val($scope.newArtSize.height)
    $('.favorite-toggle uds-toggle').attr('checked', $scope.newArtSize.isFavorite)

    $scope.select.unitValue = {
      label: $scope.newArtSize.measureUnit.toLowerCase(),
      value: $scope.newArtSize.measureUnit,
      active: true
    }

    $scope.flags.blockSearch = false

    if ($scope.newArtSize.bleedArea) {
      $scope.select.bleedValue = {
        label: api._getFormattedBleed($scope.newArtSize.bleedArea),
        value: $scope.newArtSize.bleedArea,
        active: true
      }
      return
    }

    const defaultValue = $scope.bleedAreaOptions[0]
    $scope.select.bleedValue = defaultValue
  }

  function _initializeInfiniteScroll () {
    $timeout(() => {
      const container = $('uds-tab-content[name="favorites"] .art-sizes-container')

      if (container.length) {
        container.scroll(() => {
          const loading = $scope.flags.loadingArtSizes || $scope.flags.loadingMore

          if (!loading && $scope.favorites.count > $scope.favorites.artSizes.length && container.scrollTop() + container.innerHeight() >= container[0].scrollHeight - 1) {
            if ($scope.flags.isSearching) {}
            $scope.loadMoreFavoriteArtSizes()
          }
        })
      }
    }, 500, false)
  }

  function _getFormattedBleed (bleed) {
    const regex = /([0-9]+)([A-Z]+)/g
    return bleed.replace(regex, (_, number, unit) => `${number} ${unit.toLowerCase()}`)
  }

  function _renameArtSize () {
    ArtSizesService.renameArtSize($scope.rename.id, $scope.rename.nameToEdit).then(() => {
      $scope.rename.name = $scope.rename.nameToEdit
      $scope.rename = null
    })
  }
}

export { ArtSizeDialogController }
